import React, { useEffect, useState } from "react";

function PDFInfo({
  locations,
  lostCall,
  lostCallName,
  specialInstructions,
  formatPhoneNumber,
  destinationAddress,
  destinationId,
  websiteUrl,
  websiteLinkText,
  isExport
}) {
  const [isSafari, setIsSafari] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent;
    setIsSafari(
      ua.includes("Safari") && !ua.includes("Chrome") && !ua.includes("Chromium")
    );
  }, []);

  const styles = {
    flexContainer: {
      display: "flex",
      flexWrap: "wrap",
      margin: "0px 13px 0px 10px",
      boxSizing: "border-box",
      minHeight: "auto",
      height: "auto",
      alignItems: "stretch", // ✅ ensures all items can stretch naturally
    },

    flexItem: {
      width: "350px",
      border: "3px solid #000",
      flexGrow: 1,
      padding: "10px 12px", // ✅ slightly more stable for export than 10
      minHeight: "auto",
      height: "auto",
      boxSizing: "border-box",
      margin: "0px -3px -3px 0px",
      textAlign: "center",

      display: "flex",
      flexDirection: "column",
      alignItems: "center",

      overflow: "visible", // ✅ critical: do NOT clip text on export
    },

    // Title line (TYPE)
    type: {
      display: "block",
      fontSize: "1.1em",
      fontWeight: "bold",
      width: "100%",
      textDecoration: "underline",
      lineHeight: 1.2,
      margin: 0,
      overflowWrap: "anywhere",
      wordBreak: "break-word",
      whiteSpace: "normal",
    },

    // Name line
    name: {
      display: "block",
      width: "100%",
      fontSize: "0.95em",
      fontWeight: 800,
      lineHeight: 1.25, // ✅ gives dom-to-png breathing room
      marginTop: 6,
      marginBottom: 0,
      overflowWrap: "anywhere",
      wordBreak: "break-word",
      whiteSpace: "normal",
    },

    // Address line
    address: {
      width: "100%",
      fontSize: "0.95em",
      fontWeight: 400,
      lineHeight: 1.25,
      marginTop: 4,
      marginBottom: 0,
      overflowWrap: "anywhere",
      wordBreak: "break-word",
      whiteSpace: "normal",
    },

    // Yellow box tweaks (SPECIAL INSTRUCTIONS / LOCATIONS REP)
    infoBox: {
        backgroundColor: "#ffff99",
        boxSizing: "border-box",
        paddingTop: 12,
        paddingBottom: 12,  // ✅ extra bottom padding prevents export clipping
    },

    infoText: {
        lineHeight: 1.35,     // ✅ keep
        paddingBottom: 6,     // ✅ extra space inside the text block
    },

    // exportSpacer: {
    // height: 6,
    // width: "100%",
    // flexShrink: 0,
    // },

  };

  const safeSpecial = specialInstructions ? specialInstructions : "N/A";
  const safeLostCallName = lostCallName ? lostCallName : "...";
  const safePhone = lostCall ? formatPhoneNumber(lostCall) : "";
  const safeWebsite = websiteUrl ? websiteUrl : "N/A";
  const safeWebsiteLinkText = websiteLinkText ? websiteLinkText : "";

  return (
    <div>
      {/* Top location boxes */}
      <div style={styles.flexContainer}>
        {locations.map((location, index) => {
          const isDestination = location.id === destinationId;
          const address = isDestination
            ? destinationAddress
            : location?.mapData?.address;

          return (
            <div
              key={index}
              style={{
                ...styles.flexItem,
                ...(isDestination && { backgroundColor: "rgba(255, 0, 0, 0.28)" }),
              }}
            >
              <div style={styles.type}>
                {location.type}
                {location.type === "SET" ? ` - "${location.setName}"` : ""}
              </div>

              <div style={styles.name}>{location.name}</div>

              <div style={styles.address}>{address}</div>
            </div>
          );
        })}
      </div>

      {/* Yellow info row */}
      <div style={styles.flexContainer}>
            <div style={{ ...styles.flexItem, ...styles.infoBox }}>
            <div style={styles.type}>SPECIAL INSTRUCTIONS</div>
            <div style={{ ...styles.name, ...styles.infoText }}>
                {safeSpecial}
            </div>
            {/* {isExport && <div style={styles.exportSpacer} />} */}
            </div>

            <div style={{ ...styles.flexItem, ...styles.infoBox }}>
            <div style={styles.type}>LOCATIONS REP</div>
            <div style={{ ...styles.name, ...styles.infoText, fontWeight: "bold" }}>
                Call {safeLostCallName} {safePhone}
            </div>
            {/* {isExport && <div style={styles.exportSpacer} />} */}
            </div>

            <div style={{ ...styles.flexItem, ...styles.infoBox }}>
            <div style={styles.type}>WEBSITE</div>
            <div style={{ ...styles.name, ...styles.infoText, fontWeight: "bold" }}>
                {safeWebsiteLinkText} {safeWebsite}
            </div>
            {/* {isExport && <div style={styles.exportSpacer} />} */}
            </div>

      </div>

      {/* keep isSafari around in case you later want browser-specific tweaks */}
      {/* currently unused */}
      {isSafari ? null : null}
    </div>
  );
}

export default PDFInfo;
